export default __webpack_public_path__ + "static/media/aboutUsSectionVideo.566ec347.mp4";